<template>
	<v-footer>
		<div class="footer-bottom">
			<v-container>
				<v-row>
					<v-col cols="12" md="12" class="text-center mt-3 mb-2">
						<a :href="this.frontEndUrl + '/homepage'" class="logo-anchor footer-logo"><img style="width: 300px;"
								src="/static/footer-logo.png" /></a>
					</v-col>
				</v-row>
			</v-container>
			<hr />
			<v-container style="text-align: left;">
				<v-row class="d-flex justify-content-center">
					<v-col cols="12" sm="12" md="6" lg="3" class="mt-10 black--text">
						<h3 class="footer-sub-title">IMPROVE</h3>
						<div class="footer-links">
							<a :href="this.frontEndUrl +'/why-improve'">Why IMPROVE?</a>
							<a :href="this.frontEndUrl + '/features'">Features</a>
							<a :href="this.frontEndUrl +'/course-library'">Course Library</a>
							<a :href="this.frontEndUrl +'/pricing'">Pricing</a>
							<a :href="this.frontEndUrl + '/blog'">Blog</a>
							<a :href="this.frontEndUrl + '/about-us'">About Us</a>
							<a :href="this.frontEndUrl + '/request'">Request a Demo</a>
							<a :href="this.frontEndUrl+'/contact'">Contact</a>
						</div>
					</v-col>
					<v-col cols="12" sm="12" md="6" lg="3" class="mt-10 black--text">
						<h3 class="footer-sub-title ">Courses</h3>
						<div class="footer-links">
							<a :href="this.frontEndUrl+'/course-library?course=LegislationAndRegulation'">Legislation and Regulation</a>
							<a :href="this.frontEndUrl+'/course-library?course=PeopleAndRelationships'">People and Relationships</a>
							<a :href="this.frontEndUrl+'/course-library?course=OnlineAndOfflineSafety'">Online and Offline Security</a>
							<a :href="this.frontEndUrl+'/course-library?course=DigitalAndCreativeSkills'">Digital and Creative Skills</a>
							<a :href="this.frontEndUrl+'/course-library?course=ManagementAndLeadership'">Management and Leadership</a>
							<a :href="this.frontEndUrl+'/course-library?course=WorkingFromHomeToolkit'">Working From Home Toolkit</a>
						</div>
					</v-col>
					<v-col cols="12" sm="12" md="6" lg="3" class="mt-10 black--text">
						<h3 class="footer-sub-title">Terms & Policies</h3>
						<div class="footer-links">
							<a :href="this.frontEndUrl+'/privacy-policy'">Privacy Policy</a>
							<a :href="this.frontEndUrl+'/eula'">End user license agreement</a>
							<a :href="this.frontEndUrl+'/usage-policy'">Terms of use policy</a>
						</div>
					</v-col>
					<v-col cols="12" sm="12" md="6" lg="3" class="mt-10 black--text">
						<h3 class="footer-sub-title">Contact</h3>
						<div class="footer-links">
							<a
								href="mailto:hello@improve.online?subject=Customer%20Inquiry&body=Hello%20Improve%20Team,%0A%0AI%20would%20like%20to%20inquire%20about%20...">hello@improve.com</a>
							<a href="tel:+441156786278">0115 6786278</a>
						</div>
						<h5>IMPROVE PRODUCTIONS LIMITED</h5>
						<span class="footer-item">Unit 11</span>
						<span class="footer-item">Wheatcroft Business Park</span>
						<span class="footer-item">Landmere Lane</span>
						<span class="footer-item">Edwalton</span>
						<span class="footer-item">Nottingham</span>
						<span class="footer-item">NG12 4DG</span>
						<span class="footer-item">United Kingdom</span>
						<div class="company-social">
							<a href="https://www.linkedin.com/company/improveonline" target="_blank"><img
									src="/static/icons/improve-linkedin.png" /></a>
						</div>
					</v-col>
				</v-row>
			</v-container>
			<hr />
			<div>
				<v-col cols="12" class="text-center">
					<span class="footer-company-sub-title">
						© 2024 IMPROVE PRODUCTIONS LIMITED | Registered Company Number:
						11320233
					</span>
				</v-col>
			</div>
		</div>
	</v-footer>
</template>

<style>

</style>

<script>
  export default {
    name: "FooterNavigation",
    props:{
      frontEndUrl: String,
    }
}
</script>